/**
 * Table Actions Menu - Menú contextual genérico para tablas
 * 
 * Controla el comportamiento de los menús desplegables de acciones en tablas.
 * Reutilizable para cualquier tabla que use las clases .table-actions-*
 * 
 * @package FiscalFactu
 */

( function( $ ) {
	'use strict';

	/**
	 * Inicializar menús de acciones en tablas
	 */
	function initTableActionsMenus() {
		
		// Abrir/cerrar menú al hacer clic en el trigger
		$( document ).on( 'click', '.table-actions-trigger', function( e ) {
			e.stopPropagation();
			
			var $trigger = $( this );
			var $wrapper = $trigger.closest( '.table-actions-wrapper' );
			var $menu = $wrapper.find( '.table-actions-menu' );
			var isOpen = ! $menu.attr( 'hidden' );

			// Cerrar todos los menús abiertos primero
			closeAllMenus();

			// Toggle del menú actual
			if ( ! isOpen ) {
				$menu.removeAttr( 'hidden' );
				$trigger.attr( 'aria-expanded', 'true' );
			}
		});

		// Cerrar menú al hacer clic fuera
		$( document ).on( 'click', function( e ) {
			if ( ! $( e.target ).closest( '.table-actions-wrapper' ).length ) {
				closeAllMenus();
			}
		});

		// Cerrar menú al hacer clic en una opción (no disabled)
		$( document ).on( 'click', '.table-action-item:not(.disabled)', function() {
			closeAllMenus();
		});

		// Prevenir navegación en opciones disabled
		$( document ).on( 'click', '.table-action-item.disabled', function( e ) {
			e.preventDefault();
		});

		// Cerrar menú al presionar ESC
		$( document ).on( 'keydown', function( e ) {
			if ( e.key === 'Escape' || e.keyCode === 27 ) {
				closeAllMenus();
			}
		});
	}

	/**
	 * Cerrar todos los menús abiertos
	 */
	function closeAllMenus() {
		$( '.table-actions-menu' ).attr( 'hidden', '' );
		$( '.table-actions-trigger' ).attr( 'aria-expanded', 'false' );
	}

	// Inicializar al cargar el DOM
	$( document ).ready( function() {
		initTableActionsMenus();
	});

	// Reinicializar después de AJAX (útil para DataTables)
	$( document ).on( 'draw.dt', function() {
		// Los event handlers ya están delegados, no necesitan reinicialización
		// Este evento está aquí por si necesitas lógica adicional en el futuro
	});

} )( jQuery );

